import React from 'react';

// Components
import LogoutBtnWithModal from '../../../components/LogoutBtnWithModal/LogoutBtnWithModal';
import PractitionerNavigation from './PractitionerNavigation';
import EventsBlock from './EventsBlock/EventsBlock';

// s & images
import * as s from './styles';
import LangSwitcher from 'src/components/Header/LangSwitcher';


export default () => {
  return (
    <s.AuthorizedHeaderWrapper>
      <s.AuthorizedHeader>
        {global.theme.shortLogo}
        <PractitionerNavigation />

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <EventsBlock />
          <LangSwitcher />
          <LogoutBtnWithModal btnClassName="practitioner-logout-btn" />
        </div>
      </s.AuthorizedHeader>
    </s.AuthorizedHeaderWrapper>
  );
};
